import React, {useContext} from 'react';
import {LanguageContext} from "../languages/LanguageContext";
import GalleryPreview from "./GalleryPreview";

const ImportantNews1 = () => {
	const { language, translations } = useContext(LanguageContext);
	return (
		<div className='important-container max-w flex jc-sb gap-2 w-full'>
			<div className='content-container flex gap-sm w-full jc-sb wrap'>
				<div className='flex wrap gap-sm'>
					<div className='wrapper'>
						<h3 dangerouslySetInnerHTML={{__html: translations[language]["commitment"]}}></h3>
						<ul className='list-container commitment flex col'>
							<li>{translations[language]["commitment1"]}</li>
							<li>{translations[language]["commitment2"]}</li>
						</ul>
					</div>
				</div>
				<div className='latest-news flex col'>
					<div className='news-image'>
						<img src='/images/landing/commitment.jpeg' alt='our commitment'/>
					</div>
					<GalleryPreview
						folder={'commitment/'}
						imageCount={5}
						prefix={'commitment-'}
						news={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default ImportantNews1;